define('validation',['exports', './validation--counter-boxes.es', './validation--counter-choices.es', './validation--counter-emails.es', './validation--counter-questions.es', './validation--counter-ratings.es', './validation--match-pair.es', './validation--sort-to-groups.es'], function (exports, _validationCounterBoxes, _validationCounterChoices, _validationCounterEmails, _validationCounterQuestions, _validationCounterRatings, _validationMatchPair, _validationSortToGroups) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _validationCounterBoxes2 = _interopRequireDefault(_validationCounterBoxes);

    var _validationCounterChoices2 = _interopRequireDefault(_validationCounterChoices);

    var _validationCounterEmails2 = _interopRequireDefault(_validationCounterEmails);

    var _validationCounterQuestions2 = _interopRequireDefault(_validationCounterQuestions);

    var _validationCounterRatings2 = _interopRequireDefault(_validationCounterRatings);

    var _validationMatchPair2 = _interopRequireDefault(_validationMatchPair);

    var _validationSortToGroups2 = _interopRequireDefault(_validationSortToGroups);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    exports.default = function () {
        var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


        switch (page.typeID) {
            /* istanbul ignore next */
            case 12:
                // Open Question
                return Array.isArray(page.answers) && page.answers.length ? (0, _validationCounterEmails2.default)(page.answers) : (0, _validationCounterQuestions2.default)(page.questions);
            case 13:
                // MultiChoice
                switch (page.displayMode) {
                    /* istanbul ignore next */
                    case 2:
                        // radio
                        return (0, _validationCounterChoices2.default)(page.answers);
                    /* istanbul ignore next */
                    case 3:
                        //checkbox
                        return (0, _validationCounterChoices2.default)(page.answers, page.components.checkboxminmax);
                    default:
                        return false;
                }
            case 14:
                // Yes No
                switch (page.displayMode) {
                    /* istanbul ignore next */
                    case 2:
                        // radio
                        return (0, _validationCounterRatings2.default)(page.questions);
                    /* istanbul ignore next */
                    case 8:
                        // boxes
                        return (0, _validationCounterBoxes2.default)(page.questions);
                    default:
                        return false;
                }

            /* istanbul ignore next */
            case 15:
                // Set in Order
                return (0, _validationCounterQuestions2.default)(page.questions);
            /* istanbul ignore next */
            case 16:
                // Match Pair
                return (0, _validationMatchPair2.default)(page.questions, page.answers);
            /* istanbul ignore next */
            case 17:
                // Evaluate
                return (0, _validationCounterRatings2.default)(page.questions);
            /* istanbul ignore next */
            case 18:
                // Fill Blanks
                return (0, _validationCounterQuestions2.default)(page.questions);
            case 19:
                // Quiz
                return true;
            /* istanbul ignore next */
            case 20:
                // Sort to Groups
                return (0, _validationSortToGroups2.default)(page.questions, page.answers);
            default:
                return false;
        }
    };
});
